define([
    'bignumber.js',
    'modules/common/controls/control',
    'modules/common/controls/numericinput',
    'appcontext'
], (BigNumber, Control, NumericInput, appContext) => {

    const NumericElement = Control.extend({

        binders: {
            html (view, value) {
                view.set(value);
            },
            value (view, value) {
                view.set(value);
            },
            vatDate (view, value) {
                view.setVatDate(value);
            },
            vatValue (view, value) {
                view.setVatValue(value);
            }
        },

        defaults: _.extend({}, Control.prototype.defaults, {
            type: 'integer',
            allowNull: false
        }),

        initialize () {
            Control.prototype.initialize.apply(this, arguments);
            _.defaults(this.options, {nullText: '&mdash;'});

            if (_.isString(this.options.type)) {
                this.options.type = NumericInput.types[this.options.type](this.options);
            }

            if (this.options.type.vat) {
                this.listenTo(appContext, 'changeWithVat', this.changeWithVat);
            }
        },

        render () {
            Control.prototype.render.apply(this, arguments);
            this.$el.autoNumeric('destroy').autoNumeric('init', this.options.type);
            return this;
        },

        set (value, dirty) {
            this.value = value;

            if (!this.options.allowNull) {
                value = value || 0;
            }

            if (this.options.type.vat && !dirty && this.vatXOR()) {
                value = this.newValue(new BigNumber(value));
            }

            this._set(value);
        },

        setVatDate (value) {
            this.vatDate = value;
        },

        setVatValue (value) {
            this.vatValue = value;
        },

        _set (value) {
            if (!_.isFinite(value) && this.options.allowNull) {
                this.$el.html(this.options.nullText);
            } else {
                this.$el.autoNumeric('set', value);
            }
        },

        changeWithVat () {
            const value = new BigNumber(this.value);
            this._set(this.newValue(value));
        },

        newValue (value) {
            const self = this;
            const divider = appContext.vatDivider(this.vatDate);

            function applyVAT (v) {
                if (!_.isUndefined(self.vatValue)) {
                    return new BigNumber(self.vatValue).toFixed(2);
                }

                return (appContext.withVat() ? v.times(divider) : v.div(divider)).toFixed(2);
            }

            return this.vatXOR() ? applyVAT(value) : value.toFixed(2);
        },

        vatXOR () {
            const x = appContext.withVat(); const y = this.options.type.vatInversed;
            return (x || y) && !(x && y);
        }

    });

    NumericElement.types = NumericInput.types;
    return NumericElement;
});
